import heic2any from "heic2any";
import { useEffect, useState } from "react";

import { decodeBase64ToUint8Array } from "./supportTicketAttachmentDecode";

type AttachmentPayload = {
  contentBase64: string;
  fileType: string;
};

export function useSupportAttachmentImagePreview(
  payload: AttachmentPayload | undefined,
  displayType: string,
): { imageSrc: string | null; imageError: string | null } {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [imageError, setImageError] = useState<string | null>(null);

  useEffect(() => {
    if (!payload || displayType === "application/pdf") return undefined;
    if (!displayType.startsWith("image/")) return undefined;
    let urlToRevoke: string | null = null;
    const run = async () => {
      try {
        setImageError(null);
        const bytes = decodeBase64ToUint8Array(payload.contentBase64);
        if (displayType === "image/heic") {
          const blob = new Blob([Uint8Array.from(bytes)], { type: "image/heic" });
          const converted = await heic2any({ blob, toType: "image/jpeg" });
          const jpegBlob = Array.isArray(converted) ? converted[0] : converted;
          if (!(jpegBlob instanceof Blob)) return;
          const url = URL.createObjectURL(jpegBlob);
          urlToRevoke = url;
          setImageSrc(url);
          return;
        }
        const blob = new Blob([Uint8Array.from(bytes)], { type: displayType });
        const url = URL.createObjectURL(blob);
        urlToRevoke = url;
        setImageSrc(url);
      } catch {
        setImageError("Nie udało się wyświetlić podglądu.");
        setImageSrc(null);
      }
    };
    void run();
    return () => {
      if (urlToRevoke) URL.revokeObjectURL(urlToRevoke);
    };
  }, [payload, displayType]);

  return { imageSrc, imageError };
}
